//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'icon-logo-ut',
  props: {
    light: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: true,
    },
    stroked: {
      type: Boolean,
      default: false,
    },
  },
};
